export interface ChangePatientData {
  cdSetorAtendimentoP: string;
  dsLocal: string;
  dsSetorAtendimentoP: string;
  encounterId: string;
  ieTempo: string;
  isPatientDisplacement: boolean;
  nrSequencia: string;
  personName: string;
  reasonCode: number;
  reasonDescription: string;
  sector: string;
}

export const changePatientData = {} as ChangePatientData;
